export default __webpack_public_path__ + "img/fWeYwmNl.dcc7aa66.svg";